import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmDialog.component';
import { Confirmation } from '../models/confirmation-model';


@Injectable({
  providedIn: 'root'
})

export class ConfirmationService {

  confirmFunction: any;

  constructor(public dialog: MatDialog) { }

  confirm(confirmation: Confirmation): void {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: confirmation.width ? confirmation.width : '350px',
          data: {
              confirmation: confirmation
          },
      });

      dialogRef.afterClosed().subscribe(result => {
          if (result) {
              this.confirmFunction = confirmation.accept ? confirmation.accept : () => { };
              this.onAccept();
          } else {
              this.confirmFunction = confirmation.reject ? confirmation.reject : () => { };
              this.close();
          }
      });
  }

  onAccept(): void {
      this.confirmFunction();
  }

  close(): void {
      this.confirmFunction();
  }
}
